import React from 'react'
import cn from 'classnames'
import ScrollerContext from 'components/Scroller/Context'
import { propFunc } from 'util/functions'
import ListItem from './ListItem'
import styles from './styles.less'

export default class List extends React.Component {
  static contextType = ScrollerContext

  componentDidMount() {
    this.scrollToFocusedListItem()
  }

  componentDidUpdate() {
    this.scrollToFocusedListItem()
  }

  getFocusedListItemNode() {
    const { focusedItem } = this.props
    if (!focusedItem) return null
    return this.itemRefs[focusedItem.id].current
  }

  scrollToFocusedListItem() {
    const el = this.getFocusedListItemNode()
    if (!el || !this.props.autoScroll) return false
    const { scrollElementIntoViewIfNeeded } = this.context.getScrollerAPI()
    if (!scrollElementIntoViewIfNeeded) return false
    return scrollElementIntoViewIfNeeded(el)
  }

  itemRefs = {}

  render() {
    const {
      className,
      items,
      focusedItem,
      focusedItemIcon,
      onItemClick,
      onItemFocus,
    } = this.props
    return (
      <div className={cn(className, styles.cannedReplyList)}>
        {items.map(item => {
          const isFocused = focusedItem === item
          this.itemRefs[item.id] = React.createRef()
          return (
            <ListItem
              key={`${item.type}-${item.id}`}
              onClick={propFunc(onItemClick, item)}
              onMouseMove={propFunc(onItemFocus, item, true)}
              isFocused={isFocused}
              focusedItemIcon={focusedItemIcon}
              ref={this.itemRefs[item.id]}
              {...item}
            />
          )
        })}
      </div>
    )
  }
}
